import { useEffect, useState } from "react";
import DatenerfassungTabelle from "../DatenerfassungTabelle";
import { absdatenHeader, absdCsvHeader, hiddenColumns } from "../../Tabellen/ConstTabKopf/AbschnittsdatenKopf";
import { FehlerauswertungErrResp } from "../../Fehler/FehlerauswertungErrResp";

var MonitorApi = require('monitor-api');

export function AbschnittsdatenFilter({ vvInstance, statusInstance, zvInstance, absdInstance }) {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [noData, setNoData] = useState(false);


  const [filter, setFilter] = useState(new MonitorApi.LiniendatenFilter(null, null, null, null));

  //text filter things
  const [jSearch, setJSearch] = useState("");
  const [vvSearch, setVvSearch] = useState("");
  const [zvSearch, setZvSearch] = useState("");
  const [sSearch, setSSearch] = useState("");

  // lists and their visibility
  const [ddJahre, setDdJahre] = useState([]);
  const [jShow, setJShow] = useState(false);

  const [ddVvs, setDdVvs] = useState([]);
  const [vShow, setVShow] = useState(false);

  const [ddZvs, setDdZvs] = useState([]);
  const [zShow, setZShow] = useState(false);

  const [ddStatus, setDdStatus] = useState([]);
  const [sShow, setSShow] = useState(false);

  // checkboxes
  const [jSelection, setJSelection] = useState({});
  const [jAll, setJAll] = useState(true);

  const [sSelection, setSSelection] = useState({});
  const [sAll, setSAll] = useState(true);

  const [vSelection, setVSelection] = useState({});
  const [vAll, setVAll] = useState(true);

  const [zSelection, setZSelection] = useState({});
  const [zAll, setZAll] = useState(true);

  useEffect(() => {
    absdInstance.getExistentYearsAbschnittsdaten((error, data) => {
      if (error) {
        console.log(error);
      } else {
        setDdJahre(data);
        data.map(y => setJSelection(pre => ({ ...pre, [y]: true })))
      }
    });

    statusInstance.getStatusStatusGet((error, data) => {
      if (error) {
        console.log('error', error);
      } else {
        console.log('>>load s');
        setDdStatus(data);
        data.map(d => setSSelection(previous => ({ ...previous, [d.statusEnum]: true })));
      }
    });

    vvInstance.getListVerkehrsvertragVerkehrsvertragListGet((error, data) => {
      if (error) {
        console.log('>>err: ', error);
      } else {
        console.log('>>load vv');
        setDdVvs(data);
        data.map(d => setVSelection(pre => ({ ...pre, [d.id]: true })));
      }
    });

    zvInstance.zweckverbandListeZweckverbandListeGet((error, data) => {
      if (error) {
        console.log('>>error', error);
      } else {
        console.log('>>load zv');
        setDdZvs(data);
        data.map(d => setZSelection(pre => ({ ...pre, [d.id]: true })));
      }
    });

    setTableData([]);
  }, [absdInstance, vvInstance, statusInstance, zvInstance]);

  // update checkboxes
  const updateJSelection = event => {
    setReload(true);
    setJSelection(pre => ({ ...pre, [event.target.value]: event.target.checked }));
  };
  const updateSSelection = event => {
    setReload(true);
    setSSelection(pre => ({ ...pre, [event.target.value]: event.target.checked }));
  };

  const updateVSelection = event => {
    setReload(true);
    setVSelection(pre => ({ ...pre, [event.target.value]: event.target.checked }));
  };

  const updateZSelection = event => {
    setReload(true);
    setZSelection(pre => ({ ...pre, [event.target.value]: event.target.checked }));
  };

  const deselectAll = event => {
    event.preventDefault();
    switch (event.target.value) {
      case "jahr":
        setJAll(false);
        Object.keys(jSelection).map(jahr => setJSelection(pre => ({ ...pre, [jahr]: false })));
        break;
      case "status":
        setSAll(false);
        Object.keys(sSelection).map(status => setSSelection(pre => ({ ...pre, [status]: false })));
        break;
      case "vertrag":
        setVAll(false);
        Object.keys(vSelection).map(vertrag => setVSelection(pre => ({ ...pre, [vertrag]: false })));
        break;
      case "zweckverband":
        setZAll(false);
        Object.keys(zSelection).map(zweckverband => setZSelection(pre => ({ ...pre, [zweckverband]: false })));
        break;

      default:
        break;
    }
  }
  const selectAll = event => {
    event.preventDefault();
    switch (event.target.value) {
      case "jahr":
        setJAll(true);
        Object.keys(jSelection).map(jahr => setJSelection(pre => ({ ...pre, [jahr]: true })));
        break;
      case "status":
        setSAll(true);
        Object.keys(sSelection).map(status => setSSelection(pre => ({ ...pre, [status]: true })));
        break;
      case "vertrag":
        setVAll(true);
        Object.keys(vSelection).map(vertrag => setVSelection(pre => ({ ...pre, [vertrag]: true })));
        break;
      case "zweckverband":
        setZAll(true);
        Object.keys(zSelection).map(zweckverband => setZSelection(pre => ({ ...pre, [zweckverband]: true })));
        break;

      default:
        break;
    }
  }

  //   updating filter
  useEffect(() => {
    setReload(true);
    setFilter(pre => ({ ...pre, 'jahre': Object.keys(jSelection).filter(it => jSelection[it]).map(it => parseInt(it)) }));
  }, [jSelection]);

  useEffect(() => {
    setReload(true);
    setFilter(pre => ({ ...pre, 'enums_status': Object.keys(sSelection).filter(it => sSelection[it]) }));
  }, [sSelection]);

  useEffect(() => {
    setReload(true);
    setFilter(pre => ({ ...pre, 'ids_vv': Object.keys(vSelection).filter(it => vSelection[it]).map(it => parseInt(it)) }));
  }, [vSelection]);

  useEffect(() => {
    setReload(true);
    setFilter(pre => ({ ...pre, 'ids_zv': Object.keys(zSelection).filter(it => zSelection[it]).map(it => parseInt(it)) }));
  }, [zSelection]);


  const loadingData = () => {
    setReload(false);
    setLoading(true);
    setJSearch("");
    setVvSearch("");
    setZvSearch("");
    setSSearch("");
    setTableData([]);
    console.log(filter)
    absdInstance.getFilteredAbschnittsdaten(filter, (error, data) => {
      if (error) {
        console.log(error)
      } else {
        if (data.length === 0) {
          setNoData(true);
        }
        data.map(
          row => row.fahrtenpaare === null ? row.fahrtenpaare = undefined : null
        );
        data.map(
          row => row.besetzung === null ? row.besetzung = undefined : null
        );
        data.map(
          row => row.kommentar === null ? row.kommentar = undefined : null
        );
        setTableData(data);
        setLoading(false);
        console.log(data);
      }
    })

  }

  const deleteSpecificRow = idRow => {
    console.log("lösche Zeile der Id: ", idRow);
    absdInstance.deleteAbschnittsdaten(idRow, (error, data, response) => {
      if (error) {
        console.log(error);
        FehlerauswertungErrResp(error, response);
      } else {
        console.log("Eintrag ", idRow, " ist gelöscht.");
        loadingData();
      }
    })

  }
  const saveUpdates = (updateList, resetStates, resetChanges, checkStates, setCheckStates) => {
    console.log("will speichern: ", updateList)

    absdInstance.updateAbschnittsdaten(updateList, (error, data, response) => {
      if (error) {
        console.log(error);
        FehlerauswertungErrResp(error, response);

      } else {
        resetStates("");
        Object.keys(checkStates).forEach(s => setCheckStates(pre => ({ ...pre, [s]: false })));
        resetChanges({});
        loadingData();
      }
    })
  }

  const createNewUpdateApi = () => {
    return new MonitorApi.ApiAbschnittsdatenUpdate();
  }

  //switch to csv format
  const csvIt = loadedData => {
    return loadedData.map(it =>
    ({
      ...it,
      fahrtage: it.fahrtage.toLocaleString(),
      fahrtenpaare: it.fahrtenpaare ? it.fahrtenpaare.toLocaleString() : "",
      besetzung: it.besetzung ? it.besetzung.toLocaleString() : "",
      code: btoa(JSON.stringify({
        id: it.absDatId,
        jahr: it.jahr
      }))
    }))
  }
  return (
    <div className="filter-vvd">
      <h4>Filterauswahl:</h4>

      <section className="filter-menu">
        <div className="specific-filter" onMouseLeave={() => setJShow(false)} onMouseEnter={() => setJShow(true)}>
          <input placeholder="-----Jahr-----" value={jSearch} onChange={e => setJSearch(e.target.value)} />
          {jShow && <ul type="none">
            <li>{jAll ? <button value={"jahr"} onClick={deselectAll}>Alle abwählen</button> : <button value={"jahr"} onClick={selectAll}>Alle auswählen</button>}</li>
            {ddJahre
              .filter(j => j.toString().indexOf(jSearch) > -1)
              .map(j => <li key={j}><input type="checkbox" checked={jSelection[j]} value={j} onChange={updateJSelection} />{j}</li>)}
          </ul>}
        </div>

        <div className="specific-filter" onMouseLeave={() => setSShow(false)} onMouseEnter={() => setSShow(true)}>
          <input placeholder="-----Status-----" value={sSearch} onChange={e => setSSearch(e.target.value)} />
          {sShow && <ul type="none">
            <li>{sAll ? <button value={"status"} onClick={deselectAll}>Alle abwählen</button> : <button value={"status"} onClick={selectAll}>Alle auswählen</button>}</li>
            {ddStatus
              .filter(s => s.status.toString().toLowerCase().indexOf(sSearch.toLowerCase()) > -1)
              .map(s => <li key={s.statusEnum}><input type="checkbox" checked={sSelection[s.statusEnum]} value={s.statusEnum} onChange={updateSSelection} />{s.status}</li>)}
          </ul>}
        </div>

        <div className="specific-filter zv" onMouseLeave={() => setZShow(false)} onMouseEnter={() => setZShow(true)}>
          <input placeholder="-----Zweckverband-----" value={zvSearch} onChange={e => setZvSearch(e.target.value)} />
          {zShow && <ul type="none">
            <li>{zAll ? <button value={"zweckverband"} onClick={deselectAll}>Alle abwählen</button> : <button value={"zweckverband"} onClick={selectAll}>Alle auswählen</button>}</li>
            {ddZvs
              .filter(zv => zv.verband.toString().toLowerCase().indexOf(zvSearch.toLowerCase()) > -1)
              .map(z => <li key={z.id}><input type="checkbox" checked={zSelection[z.id]} value={z.id} onChange={updateZSelection} />{z.verband}</li>)}
          </ul>}
        </div>

        <div className="specific-filter vv" onMouseLeave={() => setVShow(false)} onMouseEnter={() => setVShow(true)}>
          <input placeholder="-----Verkehrsvertrag-----" value={vvSearch} onChange={e => setVvSearch(e.target.value)} />
          {vShow && <ul type="none">
            <li>{vAll ? <button value={"vertrag"} onClick={deselectAll}>Alle abwählen</button> : <button value={"vertrag"} onClick={selectAll}>Alle auswählen</button>}</li>
            {ddVvs
              .filter(vv => vv.vertrag.toString().toLowerCase().indexOf(vvSearch.toLowerCase()) > -1)
              .map(v => <li key={v.id}><input type="checkbox" checked={vSelection[v.id]} value={v.id} onChange={updateVSelection} />{v.vertrag}</li>)}
          </ul>}
        </div>
      </section>

      <div className="filter-overview">
        <button onClick={loadingData} className={reload ? 'reload-please' : ''}>Laden</button>
        <p>ausgewählte Anzahl:</p>
        <section className="filter-overview-counter">
          <div >
            <label>Jahr: </label>
            <p>{Object.keys(jSelection).filter(it => jSelection[it]).length}</p>
          </div>

          <div>
            <label>Status: </label>
            <p>{Object.keys(sSelection).filter(it => sSelection[it]).length}</p>
          </div>

          <div>
            <label>Zweckverband: </label>
            <p>{Object.keys(zSelection).filter(it => zSelection[it]).length}</p>
          </div>

          <div>
            <label>Verkehrsvertrag: </label>
            <p>{Object.keys(vSelection).filter(it => vSelection[it]).length}</p>
          </div>
        </section>
      </div>

      <div>
        <DatenerfassungTabelle tableData={tableData} loading={loading} noData={noData} deleteSpecificRow={deleteSpecificRow} saveUpdates={saveUpdates}
          myUpdateApi={createNewUpdateApi}
          nameOfIdColumn={"absdatId"} csvIt={csvIt} deCsvHeader={absdCsvHeader} deHeader={absdatenHeader} deHiddenColumns={hiddenColumns} />
        {/* <AbschnittsdatenTabelle tableData={tableData} loadingData={loadingData} loading={loading} noData={noData} deleteSpecificRow={deleteSpecificRow} absdatInstance={absdInstance}/> */}
      </div>

    </div>
  )
}